import type { ReactNode } from 'react'
import type { ProjectRepository } from '@/domain/project/ProjectRepository'
import { RepositoryContext } from './repositoryContext'

export function RepositoryProvider({
  repository,
  children,
}: {
  repository: ProjectRepository
  children: ReactNode
}) {
  return (
    <RepositoryContext.Provider value={repository}>
      {children}
    </RepositoryContext.Provider>
  )
}
